<template>
	<div class="subscription-confirmation">
		<div class="subscription-confirmation__infoPanel">
			<div class="subscription-confirmation__logo-row">
				<a href="http://www.getopre.com/">
					<SolidTeamingWordLogo />
				</a>
			</div>
		</div>
		<div class="subscription-confirmation__actionPanel">
			<div class="subscription-confirmation__check-icon-row">
				<FontAwesomeIcon
					:icon="['fal', 'check-circle']"
					class="subscription-confirmation__check-icon"
				/>
			</div>
			<div class="subscription-confirmation__action-header">{{ $t( "slice-apple.components.SubscriptionConfirmation.thankYou" ) }}</div>
			<div class="subscription-confirmation__action-description">{{ $t( "slice-apple.components.SubscriptionConfirmation.paymentOnStatement" ) }}</div>
			<div class="subscription-confirmation__action-button-row">
				<TeamingButton @buttonPress="onBackToTeaming">{{ $t( "slice-apple.components.SubscriptionConfirmation.backToTeaming" ) }}</TeamingButton>
			</div>
		</div>
	</div>
</template>

<script>
import { SolidTeamingWordLogo, TeamingButton } from "@teaming/common-ui";
import { foundation } from "@teaming/slice-engine";

export default {
	name: "SubscriptionConfirmation",
	components: {
		SolidTeamingWordLogo,
		TeamingButton,
	},
	methods: {
		onBackToTeaming() {
			foundation().navigation.navigateToOneOnOnes();
		},
	},
	mounted() {
		// HACK to force a wait long enough for amplitude user props to have been set
		setTimeout( () => {
			foundation().telemetry.user.paymentConfirmationScreenViewed();
		}, 750 ); // eslint-disable-line no-magic-numbers
	},
};
</script>

<style lang="scss" scoped>
.subscription-confirmation {
	text-align: left;
	width: 100%;
	height: 100%;
	flex-direction: row;

	@include for-size('xs') {
		display: flex;
		flex-direction: column;
	}

	@include for-size('sm') {
		display: flex;
		flex-direction: column;
	}

	@include for-size('md') {
		display: flex;
		flex-direction: row;
	}
}

.subscription-confirmation__actionPanel {
	display: flex;
	flex-direction: column;
	max-width: 75%;
	align-items: center;
	justify-content: center;

	@include for-size('xs') {
		min-width: 100%;
		padding: 2rem 1.5rem 1.5rem 1.5rem;
	}

	@include for-size('sm') {
		min-width: 100%;
		padding: 2.5rem 3rem 3rem 3rem;
	}

	@include for-size('md') {
		min-width: 50%;
		padding: 3rem;
	}

	@include for-size('lg') {
		padding: 4rem;
	}
}

.subscription-confirmation__check-icon-row {
	height: 6rem;
}

.subscription-confirmation__check-icon {
	height: 6rem;
	width: 6rem;
	color: $subscription-confirmation-check-color;
}

.subscription-confirmation__action-header {
	@include font-and-line-for(3);
	font-weight: 600;
	margin-top: 1rem;
}

.subscription-confirmation__action-description {
	text-align: center;
	@include font-and-line-for(1);
	margin-top: 1rem;
	color: $subscription-confirmation-description-text-color;
}

.subscription-confirmation__action-button-row {
	margin-top: 1.5rem;
}

.subscription-confirmation__logo-row {
	width: 100%;
	text-align: center;

	@include for-size('xs') {
		align-self: center;
	}

	@include for-size('sm') {
		align-self: center;
	}

	@include for-size('md') {
		align-self: center;
	}

	@include for-size('lg') {
		align-self: flex-start;
	}
}

.subscription-confirmation__infoPanel {
	display: flex;
	flex-direction: column;
	background: $subscription-confirmation-info-panel-background-color;
	color: $subscription-confirmation-info-panel-font-color;
	justify-content: center;

	@include for-size('xs') {
		min-width: 100%;
		padding: 2rem 1.5rem 1.5rem 1.5rem;
	}

	@include for-size('sm') {
		min-width: 100%;
		padding: 2.5rem 3rem 3rem 3rem;
	}

	@include for-size('md') {
		min-width: 50%;
		padding: 3rem;
	}

	@include for-size('lg') {
		padding: 4rem;
	}
}

.subscription-confirmation__info-header {
	@include font-and-line-for(2);
	font-weight: 500;
	color: $subscription-confirmation-info-pale-color;
	margin-top: 1.5rem;
}

.subscription-confirmation__info-price-overview {
	margin-top:.5rem;
	display: flex;
	align-items: baseline;
}

.subscription-confirmation__info-price-amount {
	@include font-and-line-for(5);
	font-weight: 600;
	color: $subscription-confirmation-info-amount;
	margin-right: .25rem;
}

.subscription-confirmation__info-price-frequency {
	color: $subscription-confirmation-info-pale-color;
	font-weight: 600;
}

.subscription-confirmation__info-price-details {
	display: flex;
	margin-top: 2rem;
	color: $subscription-confirmation-info-amount;
	font-weight: 600;
}

.subscription-confirmation__info-price-details-amount {
	flex-grow: 1;
	text-align: right;
}

.subscription-confirmation__info-price-details-summary {
	margin-top: .15rem;
	color: $subscription-confirmation-info-pale-color;
	@include font-and-line-for(0);
	font-weight: 500;
}

.subscription-confirmation__info-price-total {
	display: flex;
	margin-top: 1rem;
	color: $subscription-confirmation-info-amount;
	font-weight: 600;
}

.subscription-confirmation__info-price-total-amount {
	flex-grow: 1;
	text-align: right;
}
</style>
